import { X } from 'lucide-react'

import { cn } from 'lib/utils'

import type { StorySpan } from '../../hooks/usePresenter'

/**
 * Jump to any story (MYD-497). Opened with S, or from the story chip in the
 * controls. For the moment an audience asks "can we see Gilroy again?": one
 * key, one click, and the presenter is at the start of that story.
 */
interface StoryMenuProps {
	stories: StorySpan[]
	currentStory: number
	onPick: (start: number) => void
	onClose: () => void
}

export function StoryMenu({ stories, currentStory, onPick, onClose }: StoryMenuProps) {
	return (
		<div className="absolute inset-0 z-30 flex items-center justify-center bg-black/70" onClick={onClose}>
			<div
				role="dialog"
				aria-label="Stories"
				className="w-[min(32rem,90vw)] rounded-xl bg-neutral-900 p-4 text-white shadow-2xl"
				onClick={event => event.stopPropagation()}
			>
				<div className="mb-3 flex items-center justify-between">
					<h2 className="text-sm font-semibold uppercase tracking-wide text-white/70">Stories</h2>
					<button type="button" onClick={onClose} className="rounded p-1 text-white/70 hover:bg-white/10 hover:text-white" aria-label="Close stories">
						<X className="h-4 w-4" />
					</button>
				</div>
				<ol className="space-y-1">
					{stories.map((story, number) => (
						<li key={`${story.storyIndex}-${story.start}`}>
							<button
								type="button"
								onClick={() => onPick(story.start)}
								aria-current={story.storyIndex === currentStory ? 'true' : undefined}
								className={cn(
									'flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-left transition-colors',
									story.storyIndex === currentStory ? 'bg-primary' : 'hover:bg-white/10',
								)}
							>
								<span className="w-6 text-sm tabular-nums text-white/60">{number + 1}</span>
								<span className="flex-1 truncate font-medium">{story.title}</span>
								<span className="text-xs tabular-nums text-white/60">
									{story.count} slide{story.count === 1 ? '' : 's'}
								</span>
							</button>
						</li>
					))}
				</ol>
			</div>
		</div>
	)
}

export default StoryMenu
